var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill2: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7826 2.26359C14.1313 1.69123 14.0606 0.931152 13.5705 0.434915C13.0757 -0.0660681 12.3153 -0.134235 11.7483 0.230412C12.2123 1.09277 12.9198 1.79999 13.7826 2.26359Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8171 1.11829L5.78472 6.18C6.77457 6.47517 7.57699 7.21908 7.95006 8.18198L12.9064 3.20208C12.0535 2.68436 11.3369 1.9696 10.8171 1.11829Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91486 9.17614C6.80538 8.1186 5.91913 7.30487 4.8592 7.29183C4.53827 7.92804 4.21105 8.90848 4.01729 9.53109C3.93355 9.80017 4.16675 10.0527 4.44262 9.99047C5.16831 9.82683 6.36057 9.52165 6.91486 9.17614Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1C1.67893 1 0 2.67893 0 4.75V10.25C0 12.3211 1.67893 14 3.75 14H9.25009C11.3212 14 13.0001 12.3211 13.0001 10.25V7C13.0001 6.58579 12.6643 6.25 12.2501 6.25C11.8359 6.25 11.5001 6.58579 11.5001 7V10.25C11.5001 11.4926 10.4927 12.5 9.25009 12.5H3.75C2.50736 12.5 1.5 11.4926 1.5 10.25V4.75C1.5 3.50736 2.50736 2.5 3.75 2.5H6C6.41421 2.5 6.75 2.16421 6.75 1.75C6.75 1.33579 6.41421 1 6 1H3.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1e16b4e7.svg";
export { ForwardRef as ReactComponent };